import utdRestClient from '_acaSrc/utility/http/UtdRestClient';
import Logger from '_acaSrc/utility/Logger';

const LOGIN_PAGE_EVENT_URL = 'event/loginPage/json';
const EVENT_PARAM_KEYS = [
    'phase',
    'status',
    'selectionChoice',
    'selectionPick',
    'count',
    'errorKey',
    'sourceCode'
];

export function buildLoginPageEventParams(action, eventParams = {}) {
    if (!action) {
        return null;
    }

    return EVENT_PARAM_KEYS.reduce((params, key) => {
        const value = eventParams[key];
        if (value !== undefined && value !== null && value !== '') {
            params[key] = value;
        }
        return params;
    }, { action });
}

export async function trackLoginPageEvent(action, eventParams = {}) {
    const params = buildLoginPageEventParams(action, eventParams);
    if (!params) {
        return;
    }

    try {
        await utdRestClient.post({
            uri: LOGIN_PAGE_EVENT_URL,
            params,
            config: { bypassAll: true }
        });
    }
    catch(e) {
        Logger.warn(`Could not record login page event:${action},exception:${e}`);
    }
}
